export default function infoDirective() {
	"ngInject";

	return {
		restrict: "E",
		replace: true,
		transclude: {
			action: "?imosButton"
		},
		templateUrl: "./components/info/info-template.html",
		scope: {
			mode: "@"
		},
		link: (scope) => {

			switch (scope.mode) {
				case "warn":
					scope.icon = "warning";
					break;
				case "severe":
				default:
					scope.icon = "info";
					break;
			}

		}
	};
}
